<nav class="main-header navbar navbar-expand app-topbar">
    <ul class="navbar-nav">
      <li class="nav-item d-none d-md-flex app-breadcrumb">
        <span>7th Haven</span>
        <i class="fas fa-chevron-right"></i>
        <strong>{{pageTitle()}}</strong>
      </li>
    </ul>
    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
        <!-- Navbar Search -->
        <li class="nav-item app-search-item d-none d-md-block">
            <div class="app-search">
                <i class="fas fa-search"></i>
                <input type="search" placeholder="Search anything..." aria-label="Search">
            </div>
        </li>
        <!-- Notifications Dropdown Menu -->
        <li class="nav-item dropdown">
            <a class="nav-link" data-toggle="dropdown" href="#">
                <i class="far fa-bell"></i>
                <span *ngIf="totalNotifications() > 0" class="badge badge-danger navbar-badge">{{totalNotifications()}}</span>
            </a>
            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                <span class="dropdown-item dropdown-header">{{totalNotifications()}} {{addS(totalNotifications(), "Notification")}}</span>
                <span *ngIf="unreadAnnouncementCount > 0">
                    <div class="dropdown-divider"></div>
                    <a [routerLink]="['/hr', 'announcements-reports']" class="dropdown-item" (click)="markAnnouncementRead()">
                        <i class="fas fa-bullhorn mr-2"></i> New announcements
                        <span class="float-right text-muted text-sm">{{unreadAnnouncementCount}}</span>
                    </a>
                    <a *ngFor="let announcement of unreadAnnouncements" [routerLink]="['/hr', 'announcements-reports']" class="dropdown-item pl-4" (click)="markAnnouncementRead(announcement)">
                        <i class="fas fa-circle mr-2 text-primary"></i> {{ announcement.title }}
                    </a>
                </span>
                <span *ngIf="(userData?.notification?.KYC || 0) > 1">
                    <div class="dropdown-divider"></div>
                    <a [routerLink]="['/users/kyc']" class="dropdown-item">
                        <i class="fas fa-envelope mr-2"></i> KYC Verification
                        <span class="float-right text-muted text-sm">{{userData?.notification?.KYC || 0}}</span>
                    </a>
                </span>
                <!-- <div class="dropdown-divider"></div>
                <a href="#" class="dropdown-item">
                <i class="fas fa-users mr-2"></i> 8 friend requests
                <span class="float-right text-muted text-sm">12 hours</span>
                </a>
                <div class="dropdown-divider"></div>
                <a href="#" class="dropdown-item">
                <i class="fas fa-file mr-2"></i> 3 new reports
                <span class="float-right text-muted text-sm">2 days</span>
                </a> -->
                <div class="dropdown-divider"></div>
                <a [routerLink]="['/hr', 'announcements-reports']" class="dropdown-item dropdown-footer">See All Notifications</a>
            </div>
        </li>
        <li class="nav-item dropdown" *ngIf="userData?.rights?.countryList?.length">
            <a class="nav-link app-country-link" data-toggle="dropdown" href="#">
                <span class="flag-icon flag-icon-{{userData?.country?.iso}} flag-icon-squared"></span>
                <span class="d-none d-lg-inline">{{userData?.country?.iso || 'Country'}}</span>
            </a>
            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                <span class="dropdown-item dropdown-header">Select Country</span>
                <div *ngFor="let countryList of userData?.rights?.countryList">
                    <div class="dropdown-divider"></div>
                    <a [routerLink]="" (click)="setLocation(countryList.iso)" class="dropdown-item">
                        <span class="flag-icon flag-icon-{{countryList.iso}} flag-icon-squared"></span>&nbsp;&nbsp;{{countryList.name}}
                        <span *ngIf="countryList.iso == userData?.country?.iso" class="float-right text-muted text-sm"><i class="fa fa-check"></i></span>
                    </a>
                </div>
            </div>
        </li>
        <li class="nav-item dropdown user-menu">
            <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown">
                <img src="https://ui-avatars.com/api/?name={{userData?.nickName || 'Admin'}}&background=073331&color=fff" class="user-image img-circle" alt="{{userData?.nickName || 'Admin'}}">
                <span class="d-none d-md-inline app-user-name">{{userData?.nickName || 'Admin'}}</span>
            </a>
            <ul class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                <!-- User image -->
                <li class="user-header app-user-header">
                <img src="https://ui-avatars.com/api/?name={{userData?.nickName || 'Admin'}}&background=073331&color=fff" class="img-circle" alt="{{userData?.nickName || 'Admin'}}">

                <p>
                    {{(userData?.lastName || '') + ' ' + (userData?.firstName || '')}}
                    <small>{{userData?.username || ''}}</small>
                </p>
                </li>
                <!-- Menu Footer-->
                <li class="user-footer">
                <a [routerLink]="['/profile']" class="btn btn-default btn-flat">Profile</a>
                <a [routerLink]="['/logout']" class="btn btn-default btn-flat float-right">Sign out</a>
                </li>
            </ul>
        </li>
    </ul>
    <div class="app-live-ticker">
        <span class="ticker-live"><i class="fas fa-bolt"></i> LIVE</span>
        <span *ngFor="let item of tickerItems" class="ticker-pair">
            <b>{{item.pair}}</b>
            <strong>{{item.value}}</strong>
            <em [class.ticker-down]="item.down">{{item.change}}</em>
        </span>
        <span class="ticker-simulated"><i class="fas fa-sync-alt"></i> {{ tickerSourceText }}</span>
    </div>
</nav>
